import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Module, Right} from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class CheckService {

  constructor(private router: Router) { }

  private modules: Module[] = JSON.parse(sessionStorage.getItem('Modules'));
  private rights: Right[] = JSON.parse(sessionStorage.getItem('Rights'));
  private rightStatus: number = +sessionStorage.getItem('RightStatus');

  checkModule(moduleId: number) {
    if (!this.modules.find(m => m.ModuleId === moduleId)) {
      this.router.navigate(['/home'], { queryParams: { message: 0 } });
    }
  }

  checkRight(rightId: number) {
    if (!this.rights.find(m => m.RightId === rightId)) {
      this.router.navigate(['/home'], { queryParams: { message: 0 } });
    }
  }

  checkRights(rightIds: number[]) {
    const map = {};
    rightIds.forEach(i => map[i] = false);
    this.rights.forEach(i => map[i.RightId] === false && (map[i.RightId] = true));
    if (Object.keys(map).map(k => ({ name: k, matched: map[k] })).find(item => item.matched)) {
      return;
    } else {
      this.router.navigate(['/home'], { queryParams: { message: 0 } });
    }
  }

  checkRightStatus(rightStatus: number) {
    if (this.rightStatus > rightStatus) {
      this.router.navigate(['/home'], { queryParams: { message: 0 } });
    }
  }
}
